import type { UserRole, CreatableUserRole } from '../types/auth';

/**
 * Rôles disponibles pour la création d'utilisateurs
 * Alignés avec le backend (CreateUserDto/InviteUserDto)
 * 
 * Note: super_admin et admin ne sont PAS créables via l'API
 */
export const AVAILABLE_ROLES: { value: CreatableUserRole; label: string; description: string }[] = [
  { value: 'accountant', label: 'Comptable', description: 'Gestion comptable et écritures' },
  { value: 'manager', label: 'Manager', description: 'Supervision et validation des opérations' },
  { value: 'analyst', label: 'Analyste', description: 'Analyse financière et rapports' },
  { value: 'audit', label: 'Auditeur', description: 'Audit des exercices comptables' },
  { value: 'viewer', label: 'Lecteur', description: 'Consultation en lecture seule' },
];

/**
 * Tous les rôles du système (incluant les rôles système non créables)
 */
export const ALL_ROLES: { value: UserRole; label: string }[] = [
  { value: 'super_admin', label: 'Super Administrateur' },
  { value: 'admin', label: 'Administrateur' },
  ...AVAILABLE_ROLES,
];

export const AVAILABLE_DEPARTMENTS: { value: string; label: string }[] = [
  { value: 'accounting', label: 'Comptabilité' },
  { value: 'finance', label: 'Finance' },
  { value: 'management', label: 'Direction' },
  { value: 'it', label: 'Informatique' },
  { value: 'hr', label: 'Ressources Humaines' },
];
